/**
 * Shared error handler for logging and user-facing messages.
 */

interface ErrorContext {
  component?: string;
  type?: string;
  refetchAvailable?: boolean;
  [key: string]: unknown;
}

function getUserMessage(error: unknown): string {
  if (!error) return "Une erreur inconnue est survenue.";

  const err = error as Record<string, unknown>;

  // Axios-style error with response
  if (err.response) {
    const status = (err.response as Record<string, unknown>).status;
    if (status === 401) return "Session expirée. Veuillez vous reconnecter.";
    if (status === 403) return "Vous n'avez pas les permissions nécessaires.";
    if (status === 404) return "Ressource introuvable.";
    if (typeof status === "number" && status >= 500)
      return "Erreur serveur. Veuillez réessayer plus tard.";
  }

  // Standard Error
  if (err.message && typeof err.message === "string") {
    return err.message;
  }

  return "Une erreur est survenue. Veuillez réessayer.";
}

function log(error: unknown, errorInfo?: unknown, context?: ErrorContext): void {
  if (import.meta.env.DEV) {
    console.error("[ErrorHandler]", error, errorInfo, context);
  }
}

function logQueryError(error: unknown, context?: ErrorContext): void {
  if (import.meta.env.DEV) {
    console.error("[QueryError]", error, context);
  }
}

export const errorHandler = { getUserMessage, log, logQueryError };
